var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "mb" },
    [
      _c(
        "w-list",
        [
          _c(
            "w-list-item",
            { staticClass: "title-container" },
            [
              _c("w-list-item-text", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ],
            1
          ),
          _c("app-invoice-list-header", { attrs: { additional: true } }),
          _vm.invoices.length > 0
            ? _c(
                "div",
                _vm._l(_vm.invoices, function (invoice) {
                  return _c("app-invoice-list-entry", {
                    key: invoice.ID,
                    attrs: {
                      invoice: invoice,
                      additional: true,
                      "can-sign": _vm.canBeSignedByClient(invoice.TypeID),
                      info: _vm.info,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.invoiceClicked(invoice)
                      },
                      sign: function ($event) {
                        return _vm.estimateSignClicked(invoice)
                      },
                    },
                  })
                }),
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "w-list-item",
                    [
                      _c(
                        "w-list-item-text",
                        [
                          _c(
                            "w-row",
                            [
                              _c("w-col", { attrs: { xs: "12" } }, [
                                _vm._v(_vm._s(_vm.$ct("empty-list"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }